import { AfterViewChecked, ChangeDetectorRef, ElementRef, OnInit } from '@angular/core';
import { NavigationEnd, NavigationStart, RouteConfigLoadEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { AuthService } from './modules/shared/services/auth.service';
import { AppLoadingEventsEmitter } from './modules/shared/events/loading.events';
import { LocalisationService } from './modules/shared/services/localisation.service';
import { Languages } from './modules/shared/enums/languages';
import { UsersService } from './modules/shared/services/users.service';
import { Constants } from './modules/shared/config/constants.config';
import { AuthEventsEmitter } from './modules/shared/events/auth.events';
import { ThemeService } from './modules/shared/services/theme.service';
var AppComponent = /** @class */ (function () {
    function AppComponent(router, changeDetectorRef, authService, appLoadingEventsEmitter, localisationService, usersService, themeService, constants, authEventsEmitter) {
        this.router = router;
        this.changeDetectorRef = changeDetectorRef;
        this.authService = authService;
        this.appLoadingEventsEmitter = appLoadingEventsEmitter;
        this.localisationService = localisationService;
        this.usersService = usersService;
        this.themeService = themeService;
        this.constants = constants;
        this.authEventsEmitter = authEventsEmitter;
        this.appLoadingClass = 'app-loading';
        this.loading = true;
        this.tidioHasBeenStyled = false;
    }
    AppComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.initLocalisation();
        this.initEventEmitters();
        document.body.classList.add(this.appLoadingClass);
        if (this.authService.userHasLoggedIn) {
            this.usersService.getUserProfile().subscribe(function () {
                _this.changeDetectorRef.detectChanges();
            });
        }
    };
    AppComponent.prototype.ngAfterViewChecked = function () {
        this.applyTidioStyles();
    };
    AppComponent.prototype.urlIsAuthRoute = function (url) {
        return url.startsWith('/login')
            || url.startsWith('/mobile-app')
            || url.startsWith('/register')
            || url.startsWith('/forgot-password')
            || url.startsWith('/reset/password');
    };
    AppComponent.prototype.urlIsWizardRoute = function (url) {
        return url.startsWith('/wizard');
    };
    AppComponent.prototype.urlIsPricingRoute = function (url) {
        return url.startsWith('/pricing') && !url.startsWith('/pricing/');
    };
    Object.defineProperty(AppComponent.prototype, "isWizardRoute", {
        get: function () {
            return this.urlIsWizardRoute(this.router.url);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppComponent.prototype, "isPricingRoute", {
        get: function () {
            return this.urlIsPricingRoute(this.router.url);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppComponent.prototype, "completeHeader", {
        get: function () {
            return !this.isWizardRoute && !this.isPricingRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppComponent.prototype, "component", {
        get: function () {
            return this;
        },
        enumerable: true,
        configurable: true
    });
    // initialize localisation
    AppComponent.prototype.initLocalisation = function (lang) {
        var _this = this;
        if (!lang) {
            var langQueryParamRegex = /lang=([a-zA-Z]{2})/g;
            var langQueryParam = langQueryParamRegex.exec(window.location.href);
            var language_1;
            // SET FROM LANG PARAM
            if (langQueryParam) {
                language_1 = langQueryParam[1].toUpperCase();
                if (this.authService.userHasLoggedIn) {
                    setTimeout(function () {
                        _this.usersService
                            .updateUserLang((language_1 === 'BG' ? Languages.Bulgarian : Languages.English))
                            .subscribe(function () {
                            console.log('lang updated');
                        });
                    }, 1);
                }
                this.localisationService.setAutoLanguage();
                return this.localisationService.useLanguage((language_1 === 'BG' ? Languages.Bulgarian : Languages.English));
            }
            // AUTO DETECT USER
            if (!this.localisationService.getAutoLanguage()) {
                this.localisationService.getUserIpData().subscribe(function (data) {
                    if (data['country'] && data['country'].length > 0 && (data['country'].toUpperCase() === 'BG' || data['country'].toUpperCase() === 'BULGARIA')) {
                        _this.localisationService.useLanguage(Languages.Bulgarian);
                    }
                    else {
                        _this.localisationService.useLanguage(Languages.English);
                    }
                    _this.localisationService.setAutoLanguage();
                }, function () {
                    // SET FROM COOKIE OR DEFAULT
                    language_1 = _this.localisationService.getLanguage();
                    if (language_1) {
                        _this.localisationService.useLanguage(language_1);
                    }
                    else {
                        _this.localisationService.useLanguage(_this.constants.defaultLanguage);
                    }
                    _this.localisationService.setAutoLanguage();
                });
                return;
            }
            // SET FROM COOKIE OR DEFAULT
            language_1 = this.localisationService.getLanguage();
            if (language_1) {
                this.localisationService.useLanguage(language_1);
            }
            else {
                this.localisationService.useLanguage(this.constants.defaultLanguage);
            }
            this.localisationService.setAutoLanguage();
        }
        else {
            // this.localisationService.setAutoLanguage();
            this.localisationService.useLanguage(lang);
        }
    };
    AppComponent.prototype.initEventEmitters = function () {
        var _this = this;
        this.authEventsEmitter.userProfileChanged$.subscribe(function (_a) {
            var locale = _a.locale;
            _this.initLocalisation(locale);
        });
        this.appLoadingEventsEmitter.appIsLoading$.subscribe(function (loading) {
            if (loading) {
                document.body.classList.add(_this.appLoadingClass);
            }
            else {
                document.body.classList.remove(_this.appLoadingClass);
            }
            _this.loading = loading;
            _this.changeDetectorRef.markForCheck();
        });
        this.router.events.pipe(filter(function (e) { return e instanceof NavigationEnd; })).subscribe(function () {
            _this.changeDetectorRef.detectChanges();
            _this.mainPanel.nativeElement.scrollTop = 0;
        });
        this.router.events
            .pipe(filter(function (e) { return e instanceof NavigationStart; }), map(function (e) { return e; }))
            .subscribe(function (_a) {
            var url = _a.url;
            var isRootPage = url === '/';
            var isErrorPage = url.startsWith('/error-404') || url.startsWith('/error-500');
            if (isRootPage || _this.urlIsAuthRoute(url) || isErrorPage) {
                _this.mainPanel.nativeElement.classList.add('w-100');
                _this.pageBodyWrapper.nativeElement.classList.add('full-page-wrapper');
                if (isErrorPage) {
                    _this.contentWrapper.nativeElement.classList.add('p-0');
                }
            }
            else {
                _this.mainPanel.nativeElement.classList.remove('w-100');
                _this.pageBodyWrapper.nativeElement.classList.remove('full-page-wrapper');
                _this.contentWrapper.nativeElement.classList.remove('p-0');
            }
        });
        this.router.events
            .pipe(filter(function (e) { return e instanceof RouteConfigLoadEnd && !!e.route.path; }))
            .subscribe(function () {
            document.body.classList.remove(_this.appLoadingClass);
            _this.loading = false;
            _this.changeDetectorRef.markForCheck();
        });
    };
    AppComponent.prototype.applyTidioStyles = function () {
        var tidio = document.querySelector('#tidio-chat-iframe');
        if (!tidio || this.tidioHasBeenStyled) {
            return;
        }
        var style = document.createElement('style');
        var css = "\n      .flyMessage {\n        display: none !important;\n      }\n\n      #button {\n        #display: none;\n      }\n\n      #button #button-body {\n        box-shadow: rgba(64, 29, 186, 0.5) 0px 4px 12px !important;\n      }\n\n      #button #new-message {\n        top: 36px !important;\n        right: 28px !important;\n      }\n\n      #button .chat-open:not(.sidebar) {\n        right: 0 !important;\n        top: 0 !important;\n      }\n    ";
        style.type = 'text/css';
        style.innerHTML = css;
        var head = tidio.contentDocument.head;
        head.append(style);
        this.tidioHasBeenStyled = true;
    };
    return AppComponent;
}());
export { AppComponent };
